import Bowser from 'bowser';

import EdgeDenied from '../../../assets/images/gif/h-edge-2.gif';
import EdgeRequest from '../../../assets/images/gif/h-edge-1.gif';
import ChromeDenied from '../../../assets/images/gif/h-chrome-2.gif';
import ChromeRequest from '../../../assets/images/gif/h-chrome-1.gif';
import SafariDenied from '../../../assets/images/gif/h-safati-2.gif';
import SafariRequest from '../../../assets/images/gif/h-safari-1.gif';

const browser = Bowser.parse(window.navigator.userAgent);
const os = browser.os.name;
const browserName = browser.browser.name;
const details = navigator.userAgent;

/* Creating a regular expression
      containing some mobile devices keywords
      to search it in details string */

/* Using test() method to search regexp in details
      it returns boolean value */
const regexp = /android|iphone|kindle|ipad/i;
const isMobileDevice = regexp.test(details);

const isMobile =
  browser.platform.type === Bowser.PLATFORMS_MAP.mobile ||
  browser.platform.type === Bowser.PLATFORMS_MAP.tablet ||
  isMobileDevice;

const RequestGif = {
  [Bowser.BROWSER_MAP.edge]: EdgeRequest,
  [Bowser.BROWSER_MAP.opera]: ChromeRequest,
  [Bowser.BROWSER_MAP.chrome]: ChromeRequest,
  [Bowser.BROWSER_MAP.safari]: SafariRequest,
  [Bowser.BROWSER_MAP.firefox]: ChromeRequest,
};

const DeniedGif = {
  [Bowser.BROWSER_MAP.edge]: EdgeDenied,
  [Bowser.BROWSER_MAP.opera]: ChromeDenied,
  [Bowser.BROWSER_MAP.chrome]: ChromeDenied,
  [Bowser.BROWSER_MAP.safari]: SafariDenied,
  [Bowser.BROWSER_MAP.firefox]: ChromeDenied,
};

const DeniedDescription = {
  [Bowser.BROWSER_MAP.edge]: 'media.permissions.denied.chrome',
  [Bowser.BROWSER_MAP.opera]: 'media.permissions.denied.chrome',
  [Bowser.BROWSER_MAP.chrome]: 'media.permissions.denied.chrome',
  [Bowser.BROWSER_MAP.safari]: 'media.permissions.denied.safari',
  [Bowser.BROWSER_MAP.firefox]: 'media.permissions.denied.chrome',
};

const MobDescriptionMap = {
  [`${Bowser.OS_MAP.iOS}_${Bowser.BROWSER_MAP.safari}`]: 'media.permissions.mob.safari',
  [`${Bowser.OS_MAP.iOS}_${Bowser.BROWSER_MAP.chrome}`]: 'media.permissions.mob.chrome_ios',
  [`${Bowser.OS_MAP.Android}_${Bowser.BROWSER_MAP.chrome}`]: 'media.permissions.mob.chrome_android',
};

const mobileData = {
  title: 'media.permissions.request.title',
  description:
    MobDescriptionMap[`${os}_${browserName}`] ||
    'media.permissions.denied.default',
  src: null,
};

export function getRequestPermissionData() {
  if (isMobile) return mobileData;

  return {
    src: RequestGif[browserName],
    title: 'media.permissions.request.title',
    description: 'media.permissions.request.description',
  };
}

export function getDeniedPermissionData() {
  if (isMobile) return mobileData;

  return {
    src: DeniedGif[browserName],
    title: 'media.permissions.denied.title',
    description:
      DeniedDescription[browserName] || 'media.permissions.denied.default',
  };
}

export function hasDevicePermissions(devices = []) {
  if (isMobile) {
    return !devices.some(device => device.label === '');
  }

  return !devices.some(device => device.deviceId === undefined);
}

export const DEVICE_PERMISSION_TYPES = {
  REQUEST: 'request',
  DENIED: 'denied',
};



// WEBPACK FOOTER //
// ./src/redux/opentok/helpers/devicePermissionHelper.js